import { Grid } from 'antd';

/** 窄于 md（768px）视为移动端 */
export function useIsMobile() {
  const screens = Grid.useBreakpoint();
  // 首次渲染 screens 可能为空，默认按桌面处理避免闪烁；有值后再判断
  if (screens.md === undefined && screens.xs === undefined) {
    return typeof window !== 'undefined' ? window.innerWidth < 768 : false;
  }
  return !screens.md;
}
